import React, {ButtonHTMLAttributes} from 'react'
import {ButtonStyled} from './styled';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    color?: string,
    width?: string,
    className?: string,
}

const Button: React.FC<ButtonProps> = ({
                                           color = 'rgba(112, 111, 211,1.0)',
                                           width = 'medium',
                                           children,
                                           onClick,
                                           className,
                                           type,
                                           disabled
                                       }) => {
    return (
        <ButtonStyled
            color={color}
            className={"btn-" + width + " " + className}
            onClick={onClick}
            type={type}
            disabled={disabled}
        >
            {children}
        </ButtonStyled>
    )
}

export default Button;
